(function(){

    /*
    * Ottimizzazione riproduzione video Hero
    * */

    const v = document.getElementById('heroVideo');
    if (!v) return;

    // Muted + inline: richiesti per autoplay su iOS
    v.muted = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const prefersReducedData   = window.matchMedia?.('(prefers-reduced-data: reduce)').matches === true;
    const saveData             = (navigator.connection && navigator.connection.saveData) === true;

    // Se utente non vuole movimento o dati: mostra poster e ferma tutto
    if (prefersReducedMotion || prefersReducedData || saveData) {
        v.removeAttribute('autoplay');
        v.pause();
        // Non caricare le sorgenti per risparmiare dati
        return;
    }

    // Carica effettivamente gli URL dalle data-* quando entra in viewport
    const hydrateSources = () => {
        const sources = v.querySelectorAll('source[data-src]');
        sources.forEach(s => {
            if (!s.src) s.src = s.getAttribute('data-src');
            s.removeAttribute('data-src');
        });
        // Forza ricalcolo delle sorgenti e tenta il play
        v.load();
        tryPlay();
    };

    const tryPlay = () => {
        const p = v.play();
        if (p && typeof p.catch === 'function') {
            p.catch(() => {
                // Ritenta in caso di blocco temporaneo
                setTimeout(() => v.play().catch(()=>{}), 80);
            });
        }
    };

    // Lazy init: parte appena il blocco è visibile (~10% visibilità)
    const io = new IntersectionObserver((entries) => {
        const visible = entries.some(e => e.isIntersecting);
        if (visible) {
            hydrateSources();
            io.disconnect();
        }
    }, { rootMargin: '200px 0px', threshold: 0.1 });

    io.observe(v);

    // Se per qualche motivo i sorgenti sono già presenti (es. hai usato <link rel="preload">), prova subito
    if (v.querySelector('source:not([data-src])')) {
        tryPlay();
    } else {
        // Se vuoi avvio istantaneo sopra la fold senza IO, scommenta:
        hydrateSources();
    }

    // Riprendi il loop quando torni dalla bfcache
    window.addEventListener('pageshow', (e) => { if (e.persisted) tryPlay(); });

    // Pausa quando la scheda è nascosta (risparmio batteria)
    document.addEventListener('visibilitychange', () => {
        if (document.hidden) v.pause(); else tryPlay();
    }, false);



    /*
    * Allineamento voci nella sezione "Dati"
    * */
    const img = document.getElementById('data-img');
    const titlesWrap = document.getElementById('data-rows');

    if (!img || !titlesWrap) return;

    // funzione che sincronizza l’altezza dei titoli con quella dell’immagine
    function syncHeights() {
        // su mobile (ad es. <576px) puoi scegliere di non forzare l’altezza
        if (window.matchMedia('(max-width: 991.98px)').matches) {
            titlesWrap.style.height = '';
            return;
        }
        const h = img.clientHeight; // altezza renderizzata dell’immagine
        if (h > 0) titlesWrap.style.height = h + 'px';
    }

    // quando l’immagine è caricata
    if (img.complete) syncHeights();
    else img.addEventListener('load', syncHeights, { once: true });

    // osserva cambi di dimensione dell’immagine (responsive/video swap)
    if ('ResizeObserver' in window) {
        const ro = new ResizeObserver(syncHeights);
        ro.observe(img);
    } else {
        // fallback
        window.addEventListener('resize', syncHeights);
        window.addEventListener('orientationchange', syncHeights);
    }



    /*
    * Inizializzazione Swiper.js per team
    * */
    var swiper = new Swiper(".swiperTeam", {
        slidesPerView: 2.4,
        spaceBetween: 10,
        freeMode: true,
        grabCursor: true,
        navigation: {
            prevEl: ".swiper-button-prev",
            nextEl: ".swiper-button-next",
        },
        breakpoints: {
            768: {
                slidesPerView: 3.5,
                spaceBetween: 15
            },
            1200: {
                slidesPerView: 4.5,
                spaceBetween: 15
            },
            1400: {
                slidesPerView: 5.5,
                spaceBetween: 15
            },
        },
    });

})();
